<template>
  <div class="ele-body">
    <el-card shadow="never">
      <div class="ele-table-tool ele-table-tool-default">
        <el-button @click="addScore" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small">添加</el-button>
        <el-button @click="settingExam" type="primary" icon="el-icon-setting" class="ele-btn-icon" size="small">考核配置</el-button>
      </div>
      <ele-data-table ref="table" :config="table" :choose.sync="choose" row-class-name="custom-row-class" highlight-current-row>
        <template>
          <el-table-column type="selection" width="45" align="center" />
          <el-table-column prop="score" label="分值" show-overflow-tooltip align="center" />
          <el-table-column prop="levelName" label="提示语" show-overflow-tooltip align="center" />
          <el-table-column label="操作" align="center">
            <template #default="{ row }">
              <el-link @click="editScore(row)" icon="el-icon-edit" type="primary" :underline="false">编辑</el-link>
              <el-popconfirm title="确定要删除此数据？" @onConfirm="deleteScore(row)" class="ele-action">
                <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false">删除</el-link>
              </el-popconfirm>
            </template>
          </el-table-column>
        </template>
      </ele-data-table>
    </el-card>
    <!--添加修改评测等级-->
    <el-dialog
      :title="editForm.id ? '修改' : '添加'"
      :visible.sync="showEdit"
      width="400px"
      @closed="resetExamForm"
      :destroy-on-close="true"
      custom-class="ele-dialog-form"
      :lock-scroll="false"
    >
      <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="80px">
        <el-form-item label="分值:" prop="score">
          <el-input v-model="editForm.score" placeholder="请输入分值" clearable />
        </el-form-item>
        <el-form-item label="提示语:" prop="levelName">
          <el-input v-model="editForm.levelName" placeholder="请输入提示语" clearable />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showEdit = false">取消</el-button>
        <el-button type="primary" @click="saveScore">保存</el-button>
      </div>
    </el-dialog>
    <!--考核初始分弹窗-->
    <el-dialog title="初始分" :visible.sync="showSetting" width="400px" :destroy-on-close="true" custom-class="ele-dialog-form" :lock-scroll="false">
      <div style="display: flex;align-items: center;margin-bottom: 20px">
        <div style="width: 80px;">分值：</div>
        <el-input v-model="score" placeholder="请输入分值" clearable />
      </div>
      <div slot="footer">
        <el-button @click="showSetting = false">取消</el-button>
        <el-button type="primary" @click="saveSetting">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { delAccessLevel, getAccessScore, saveAccessLevel, saveAccessScore } from '@/config/fengyi/examine';

  export default {
    name: 'Score',
    data() {
      return {
        table: {
          // 表格配置
          url: '/fyAccess/getAccessLevelList',
          method: 'GET',
          where: {},
          page: false,
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            return res;
          },
        },
        choose: [],
        editForm: {
          levelName: null,
          score: null,
        },
        editRules: {
          levelName: [{ required: true, message: '请输入提示语', trigger: 'blur' }],
          score: [{ required: true, message: '请输入分数', trigger: 'blur' }],
        },
        showEdit: false,
        showSetting: false,
        score: null,
      };
    },
    methods: {
      // 打开初始分值弹窗
      settingExam() {
        this.showSetting = true;
        this.getSetting();
      },
      // 设置初始分值
      saveSetting() {
        let formData = new FormData();
        formData.append('score', this.score);
        saveAccessScore(formData).then((res) => {
          if (res.data.resCode == 200) {
            this.showSetting = false;
            this.$message({ type: 'success', message: res.data.resMsg });
          }
        });
      },
      // 获取考核初始分
      getSetting() {
        getAccessScore().then((res) => {
          if (res.data.resCode == 200) {
            this.score = res.data.data.score;
          }
        });
      },
      // 打开添加弹窗
      addScore() {
        this.showEdit = true;
      },
      // 打开编辑弹窗
      editScore(row) {
        this.editForm = Object.assign({}, row);
        this.showEdit = true;
      },
      // 保存考核等级
      saveScore() {
        this.$refs['editForm'].validate((valid) => {
          if (valid) {
            const loading = this.$loading({ lock: true });
            let formData = new FormData();
            for (let key in this.editForm) {
              if (this.editForm[key] !== null && this.editForm[key] !== undefined) {
                formData.append(key, this.editForm[key]);
              }
            }
            saveAccessLevel(formData).then((res) => {
              loading.close();
              if (res.data.resCode == 200) {
                this.showEdit = false;
                this.$message({ type: 'success', message: res.data.resMsg });
                this.$refs.table.reload();
              } else {
                this.$message.error(res.data.resMsg);
              }
            });
          } else {
            return false;
          }
        });
      },
      // 删除
      deleteScore(row) {
        const loading = this.$loading({ lock: true });
        let formData = new FormData();
        formData.append('ids', row.id);
        delAccessLevel(formData).then((res) => {
          loading.close();
          if (res.data.resCode == 200) {
            this.$message({ type: 'success', message: res.data.resMsg });
            this.$refs.table.reload();
          } else {
            this.$message.error(res.data.resMsg);
          }
        });
      },
      // 重置表单
      resetExamForm() {
        this.editForm = {
          levelName: null,
          score: null,
        };
        this.$refs['editForm'].resetFields();
      },
    },
  };
</script>

<style>
  .custom-row-class {
    height: 50px !important;
  }
</style>
